<template>
  <DeleteConfirmationNumberModal
    :action="action"
    :customBodyText="bodyText"
    :customConfirmationText="confirmationText"
    :customHeaderText="headerText"
    :itemType="itemType"
  />
</template>

<script>
import { ItemTypeDisplayNames, StoreModuleMap } from 'client/util/Constants';
import { extend } from 'lodash';
import { mapGetters } from 'vuex';
import DeleteConfirmationNumberModal from 'client/components/Modal/DeleteConfirmationNumberModal.vue';
import pluralize from 'pluralize';

export default {
  name: 'VppSoftwareAppsDeleteModal',

  components: {
    DeleteConfirmationNumberModal,
  },

  props: {
    action: {
      required: true,
      type: Function,
    },
    itemType: {
      required: true,
      type: String,
    },
  },

  computed: {
    bodyText() {
      const selectedCount = this.selectedItems.length;
      const baseText = `**${selectedCount}** ${pluralize(this.notificationDisplayName, selectedCount)} selected for deletion.\n\n**Are you sure** you would like to delete the selected ${this.softwareAppsNoun}? If you do, you won’t be able to deploy ${pluralize('this', selectedCount)} ${pluralize(this.notificationDisplayName, selectedCount)} using JumpCloud. On devices where you deployed ${pluralize('this', selectedCount)} ${pluralize(this.notificationDisplayName, selectedCount)}`;

      return (selectedCount > 1)
        ? `${baseText}, they remain and are not uninstalled.`
        : `${baseText}, it remains and is not uninstalled.`;
    },

    confirmationText() {
      return `Please confirm the number of ${this.softwareAppsNounCap} to be deleted.`;
    },

    headerText() {
      return `Delete ${this.softwareAppsNounCap}`;
    },

    notificationDisplayName() {
      return `${this.softwareAppsNoun} package`;
    },

    softwareAppsNoun() {
      return (this.softwareAppsNounCap).toLowerCase();
    },

    softwareAppsNounCap() {
      return ItemTypeDisplayNames[this.itemType];
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;
    const storeModule = StoreModuleMap[itemType];

    extend(
      this.$options.computed,
      mapGetters(storeModule, {
        selectedItems: 'getSelectedItems',
      }),
    );
  },
};
</script>
